import { EdgeProps } from "reactflow";
import EdgeBaseWrapper from "./EdgeBaseWrapper";
import { memo } from "react";

const FlowGlobalEdge = (props: EdgeProps) => {
  const gradientId = `flow-gradient-${props.id}`;
  const selectedGradientId = `selected-gradient-${props.id}`;

  const edgeStyle = {
    stroke: props.selected
      ? `url(#${selectedGradientId})`
      : `url(#${gradientId})`,
    strokeDasharray: "none",
    strokeWidth: props.selected ? 9 : 7,
  };

  return (
    <EdgeBaseWrapper {...props} style={edgeStyle}>
      <defs>
        <linearGradient
          id={gradientId}
          gradientUnits="userSpaceOnUse"
          x1={props.sourceX}
          y1={props.sourceY}
          x2={props.targetX}
          y2={props.targetY}
        >
          <stop offset="0%" stopColor="white" />
          <stop offset="100%" stopColor="blue" />
        </linearGradient>
        {props.selected && (
          <linearGradient
            id={selectedGradientId}
            gradientUnits="userSpaceOnUse"
            x1={props.sourceX}
            y1={props.sourceY}
            x2={props.targetX}
            y2={props.targetY}
          >
            <stop offset="0%" stopColor="#3650DE" />
            <stop offset="100%" stopColor="#3650DE" />
          </linearGradient>
        )}
      </defs>
    </EdgeBaseWrapper>
  );
};

export default memo(FlowGlobalEdge);
